import { FC, useEffect } from 'react';
import { DotSpinner } from '@crono-one/design-system';

import { buildZohoLoginUrl } from 'hooks/services/zoho/zohoOauthState';

/**
 * Entry point for a Zoho connect started on another origin (local
 * development): mints the state nonce on this origin, which is where Zoho
 * redirects back to, then hands off to Zoho.
 */
const ZohoLoginStart: FC = () => {
  useEffect(() => {
    window.location.replace(buildZohoLoginUrl());
  }, []);

  return (
    <div className="flex h-full w-full items-center justify-center">
      <DotSpinner />
    </div>
  );
};

export default ZohoLoginStart;
